import { analyticsGtm } from '../config'

export default function CookieControlFactory({ language = 'en' }) {
  const returnCookieScript = () => {
    return {
      __html: `
    var _googleTagManagerID = "${analyticsGtm}"
    var getCookie = function(name){
      var value="; "+document.cookie;var parts=value.split("; "+name+"=");if(parts.length==2)return parts.pop().split(";").shift()
    }
    
    var cookieTranslations = document.getElementById('cookieconsenttranslations');

    if (!document.documentElement.dataset) {
      Object.defineProperty(Element.prototype, 'dataset', {
        get: function() {
          var element = this;
          var attributes = this.attributes;
          var map = {};

          for (var i = 0; i < attributes.length; i++) {
            var attribute = attributes[i];

            if (attribute && attribute.name && (/^data-\w[\w\-]*$/).test(attribute.name)) {
              var name = attribute.name;
              var value = attribute.value;

              var propName = name.substr(5).replace(/-./g, function (prop) {
                return prop.charAt(1).toUpperCase();
              });

              Object.defineProperty(map, propName, {
                enumerable: true,
                get: function() {
                  return this.value;
                }.bind({value: value || ''}),
                set: function setter(name, value) {
                  if (typeof value !== 'undefined') {
                    this.setAttribute(name, value);
                  } else {
                    this.removeAttribute(name);
                  }
                }.bind(element, name)
              });
            }
          }

          return map;
        }
      });
    }

    var cookieConfig = {
      apiKey: 'f0730a01670a0cf09920d5df663b31caaacbd295',
      product: 'PRO_MULTISITE',
      initialState: 'notify',
      layout: 'slideout',
      position: 'left',
      theme: 'light',
      logConsent: true,
      onLoad: function(e) {
        // first check status of all checkboxes and create styling.
        var toggles = document.querySelectorAll('.checkbox-toggle-toggle')
        var checkboxes = document.querySelectorAll('#ccc-optional-categories input')

        Array.prototype.forEach.call(toggles, function(item, index) {
          if (checkboxes[index].checked) {
            item.setAttribute('style', 'background-color: #4BB543')
          } else {
            item.setAttribute('style', '')
          }
        })

        var _open = CookieControl.open;
        var _hide = CookieControl.hide;
        var _update = CookieControl.update;
        var _savecookie = CookieControl.saveCookie;
        var _notifyAccept = CookieControl.notifyAccept;
        var _toggleCategory = CookieControl.toggleCategory;

        // we also need to hack the toggle cat function as we need to implement a colorchange.
        CookieControl.toggleCategory = function (num, toggled) {
          var parent = document.getElementById('ccc-optional-categories');
          var _info = parent.querySelector('#savedInfo')

          if (_info) {
            parent.removeChild(_info)
          }
          var checkboxChecked = parent.childNodes[num].querySelector('input').checked
          var toggle = parent.childNodes[num].querySelector('.checkbox-toggle-toggle')

          if (checkboxChecked) {
            toggle.setAttribute('style', 'background-color: #4BB543')
          } else {
            toggle.setAttribute('style', '')
          }


          var savedInfo = document.createElement('p')
          savedInfo.id = 'savedInfo'
          savedInfo.textContent =  cookieTranslations.dataset.changessaved
          parent.appendChild(savedInfo)

          setTimeout(function() {
            try {
              parent.removeChild(savedInfo)
            } catch (e) {
              // we don't care about dom exceptions here.
            }
          },
          7000)

          _toggleCategory(num, toggled)
        }

        CookieControl.notifyAccept = function() {
          var _html = document.getElementsByTagName('html')[0]
          _html.classList.remove('u--menu-open')

          _notifyAccept()
        }

        CookieControl.saveCookie = function() {
          _savecookie()
        }

        CookieControl.open = function() {
          var _html = document.getElementsByTagName('html')[0]
          _html.classList.add('u--menu-open')
          _open()

          var controlledElement = document.getElementById('ccc-content');
          var children = controlledElement.childNodes

          for (var i = 0, len = children.length; i < len; i++) {
            var elem = children[i];

            if (elem.nodeType !== 1 ) continue;

            var id = elem.id || elem.getAttribute('id');

            if (id === 'ccc-close') {
              elem.addEventListener('click', function() {
                CookieControl.hide();
              })
            }
          }

          return;
        }

        CookieControl.update = function() {
          _update()
        }

        CookieControl.hide = function() {
          var _html = document.getElementsByTagName('html')[0]
          _html.classList.remove('u--menu-open')
          _hide()
          return
        }
      },

      // Text
      text: {
        title: cookieTranslations.dataset.title,
        intro: cookieTranslations.dataset.description,
        notifyTitle: cookieTranslations.dataset.notifytitle,
        notifyDescription: cookieTranslations.dataset.notifydescription,
        accept: cookieTranslations.dataset.accept,
        settings: cookieTranslations.dataset.settings,
        closeLabel: cookieTranslations.dataset.closelabel,
        accessibilityAlert: '',
        necessaryTitle: cookieTranslations.dataset.necessarylabel,
        necessaryDescription: cookieTranslations.dataset.necessarydescription,
        acceptRecommended: cookieTranslations.dataset.necessarypredefinedsettings
      },
      // Branding
      branding: {
        removeIcon: true,
        removeAbout: true,
        fontColor: '#fff',
        backgroundColor: 'rgba(30,30,30,0.92)',
        acceptBackground: '#e52236',
        acceptText: '#fff',
        alertText: '#fff',
        alertBackground: 'rgba(30,30,30,0.92)'
      },
      necessaryCookies: [
          'wt_cookies_accepted',
          'wt_marketingcookies_accepted'
        ],
      optionalCookies: [
        {
          name: 'analytics',
          label: cookieTranslations.dataset.analyticslabel,
          description: cookieTranslations.dataset.analyticsdescription,
          cookies: ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv', 'G_ENABLED_IDPS', 'NID', 'IDE', 'test_cookie'],
          recommendedState: true,
          lawfulBasis: 'consent',
          onAccept: function () {
            document.cookie = 'wt_cookies_accepted=true; expires=Thu 31 Dec 2099 23:59:59 GMT';

            ;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer',_googleTagManagerID);

          },
          onRevoke: function () {
            document.cookie = 'wt_cookies_accepted=false; expires=Thu 31 Dec 2099 23:59:59 GMT'
          }
        },
        {
          name: 'marketing',
          label: cookieTranslations.dataset.marketinglabel,
          description: cookieTranslations.dataset.marketingdescription,
          cookies: ['_fbp', 'fr'],
          recommendedState: true,
          lawfulBasis: 'consent',
          onAccept: function () {
            document.cookie = 'wt_marketingcookies_accepted=true; expires=Thu 31 Dec 2099 23:59:59 GMT';

            !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
            n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
            document,'script','//connect.facebook.net/en_US/fbevents.js');

            fbq('init', '1941281276127675');
            fbq('track', 'PageView');
            fbq('consent', 'grant');
          },
          onRevoke: function () {
            document.cookie = 'wt_marketingcookies_accepted=false; expires=Thu 31 Dec 2099 23:59:59 GMT';

            if (fbq) {
              fbq('consent', 'revoke');
            }
          }
        }
      ],
    };
      CookieControl.load( cookieConfig );
    `
    }
  }
  const translations = {
    de: (
      <div
        id="cookieconsenttranslations"
        style={{ display: 'none' }}
        i18nattributes="data-notifytitle;
        data-title;
        data-description;
        data-notifydescription;
        data-accept;
        data-settings;
        data-necessarypredefinedsettings;
        data-necessarylabel;
        data-necessarydescription;
        data-closelabel;
        data-accessibilityalert;
        data-analyticsdescription;
        data-analyticslabel;
        data-marketingdescription;
        data-marketinglabel;
        data-changessaved"
        data-notifytitle="Diese Website verwendet Cookies."
        data-title="Über Cookies auf dieser Website"
        data-description="Einige dieser Cookies sind von wesentlicher Bedeutung während andere uns dabei helfen, Ihre Erfahrung zu verbessern, indem sie Einblick in die Verwendung der Website geben. Detaillierte Informationen zu den von uns verwendeten Cookies finden Sie in unserer Datenschutzerklärung."
        data-notifydescription="Um Ihnen den bestmöglichen Service bieten zu können, benutzen wir in unseren Webauftritten Cookies. Diese werden benötigt um die Funktion der Webseiten, Statistiken und Auswertungen, sowie auf Ihre Interessen zugeschnittene Inhalte, zu ermöglichen. Sollten Sie dies nicht wünschen, können Sie Ihre Standardeinstellungen unter „Erweiterte Einstellungen“ verändern."
        data-accept="Ok"
        data-settings="Erweiterte Einstellungen"
        data-necessarypredefinedsettings="Alle Cookies akzeptieren"
        data-necessarylabel="Notwendige Cookies"
        data-necessarydescription="Notwendige Cookies sind zum Betrieb der Website erforderlich. Daher können diese Cookies nur über den Browser blockiert werden."
        data-closelabel="Schliessen"
        data-accessibilityalert=""
        data-analyticsdescription="Analytics Cookies ermöglichen uns Einblick in die Verwendung der Website."
        data-analyticslabel="Analytics Cookies"
        data-marketingdescription="Wir verwenden Marketing Cookies um die Relevanz von Werbekampagnen zu verbessern."
        data-marketinglabel="Marketing Cookies"
        data-changessaved="Einstellungen wurden gespeichert."
      />
    ),
    en: (
      <div
        id="cookieconsenttranslations"
        style={{ display: 'none' }}
        data-notifytitle="This site uses cookies."
        data-title="About cookies on this website"
        data-description="Some of these cookies are essential, while others help us to improve your experience by letting us see how the website is being used. For more detailed information on the cookies we use, please check our <a href='https://www.wien.info/en/privacy-policy'>privacy policy</a>."
        data-notifydescription="To provide you the best service, we use cookies. Those are necessary for the unimpeded functioning of its websites, to secure login data, to collect statistics that optimize the website's functions, and to supply content tailored to your interests. If you want to adjust the settings, click on 'Advanced settings' to change them."
        data-accept="OK"
        data-settings="Advanced settings"
        data-necessarypredefinedsettings="Accept all cookies"
        data-necessarylabel="Necessary cookies"
        data-necessarydescription="Necessary cookies are required for the website to function properly. These cookies can therefore only be blocked via the browser."
        data-closelabel="Close"
        data-accessibilityalert=""
        data-analyticsdescription="Analytical cookies help us to see how the website is being used."
        data-analyticslabel="Analytical cookies"
        data-marketingdescription="We use marketing cookies to improve the relevancy of advertising campaigns."
        data-marketinglabel="Marketing cookies"
        data-changessaved="Settings have been saved"
      />
    ),
    it: (
      <div
        id="cookieconsenttranslations"
        style={{ display: 'none' }}
        data-notifytitle="Questo sito fa uso dei cookie."
        data-title="Informazioni sui cookie utilizzati da questo sito"
        data-description="Alcuni di questi cookie sono essenziali, mentre altri ci aiutano semplicemente a migliorare l’esperienza di navigazione dell’utente durante l’utilizzo del sito. Informazioni dettagliate sui cookie da noi utilizzati sono consultabili nella nostra <a href='https://www.wien.info/it/privacy-policy'>Informativa sulla privacy</a>."
        data-notifydescription="L’Ente per il Turismo di Vienna impiega cookie che sono necessari per il perfetto funzionamento delle pagine web. In base alle vostre impostazioni, l’Ente per il Turismo di Vienna può utilizzare i cookie anche per migliorare la vostra esperienza di navigazione, per proteggere i dati di accesso e salvarli per la gestione della sessione, per raccogliere dati statistici, per ottimizzare le funzioni del sito e fornire contenuti mirati sulla base dei vostri interessi. Memorizziamo le impostazioni da voi effettuate sia qui che in applicazioni specifiche, in cui vengono acquisite ulteriori impostazioni per i cookie."
        data-accept="Ok"
        data-settings="Impostazioni avanzate"
        data-necessarypredefinedsettings="Accetta tutti i cookie"
        data-necessarylabel="Cookie necessari"
        data-necessarydescription="I cookie necessari sono quelli indispensabili per il funzionamento del sito web. Per questo motivo questi cookie possono essere bloccati solo tramite il browser."
        data-closelabel="Chiudi"
        data-accessibilityalert=""
        data-analyticsdescription="I cookie Analytics ci permettono di monitorare l’utilizzo del sito web."
        data-analyticslabel="Cookie Analytics"
        data-marketingdescription="Utilizziamo cookie di marketing al fine di migliorare l’efficacia delle campagne pubblicitarie."
        data-marketinglabel="Cookie di marketing"
        data-changessaved="Le impostazioni sono state salvate"
      />
    ),
    fr: (
      <div
        id="cookieconsenttranslations"
        style={{ display: 'none' }}
        data-notifytitle="Ce site utilise des cookies."
        data-title="À propos des cookies sur ce site Internet"
        data-description="Certains de ces cookies sont essentiels tandis que d'autres nous aident à améliorer votre expérience en nous donnant des informations sur l'utilisation que vous faites du site Internet. Pour de plus amples informations sur les cookies que nous utilisons, veuillez consulter notre <a href='https://www.wien.info/fr/privacy-policy'>déclaration de protection des données</a>."
        data-notifydescription="L'Office de Tourisme de Vienne utilise des cookies nécessaires au bon fonctionnement de ses sites Internet. En fonction de vos paramètres, l'Office de Tourisme de Vienne peut également utiliser des cookies pour améliorer votre expérience, sécuriser et stocker des données de connexion pour la gestion de session, compiler des statistiques, optimiser les fonctions du site Internet et vous fournir des contenus sur mesure. Nous enregistrons les paramètres que vous choisissez, aussi bien ici que dans certaines applications exigeant d'autres paramètres de cookies spécifiques."
        data-accept="Ok"
        data-settings="Paramètres avancés"
        data-necessarypredefinedsettings="Accepter tous les cookies"
        data-necessarylabel="Cookies nécessaires"
        data-necessarydescription="Ces cookies sont nécessaires à l'exploitation du site Internet. Ils ne peuvent donc être bloqués que dans votre navigateur."
        data-closelabel="Fermer"
        data-accessibilityalert=""
        data-analyticsdescription="Les cookies d'Analytics nous donnent des informations sur l'utilisation du site Internet."
        data-analyticslabel="Cookies Analytics"
        data-marketingdescription="Nous utilisons des cookies de marketing pour améliorer la pertinence de nos campagnes publicitaires."
        data-marketinglabel="Cookies marketing"
        data-changessaved="Vos réglages ont été enregistrés"
      />
    ),
    es: (
      <div
        id="cookieconsenttranslations"
        style={{ display: 'none' }}
        data-notifytitle="Este sitio utiliza cookies."
        data-title="Información sobre las cookies de este sitio web"
        data-description="Algunas de estas cookies son importantes, mientras que otras tienen la finalidad de ayudarnos a mejorar su experiencia al permitirnos ver qué uso hace del sitio web. Encontrará información detallada sobre las cookies que usamos en nuestra <a href='https://www.wien.info/es/privacy-policy'>declaración de protección de datos</a>."
        data-notifydescription="WienTourismus emplea cookies necesarias para el correcto funcionamiento de los sitios web. En función de sus ajustes, WienTourismus también puede utilizar cookies para mejorar su experiencia, proteger sus datos de acceso y almacenar la gestión de sesión, optimizar las funciones del sitio web y de aquellos contenidos que se correspondan con sus intereses. Almacenamos los ajustes que usted seleccione, tanto aquí como en las aplicaciones específicas en las que se recopilan ulteriores ajustes para cookies de forma concreta."
        data-accept="Aceptar"
        data-settings="Ajustes adicionales"
        data-necessarypredefinedsettings="Aceptar todas las cookies"
        data-necessarylabel="Cookies necesarias"
        data-necessarydescription="Algunas cookies son necesarias para el correcto funcionamiento del sitio web. Por ese motivo, solo podrá bloquear estas cookies a través de su navegador."
        data-closelabel="Cerrar"
        data-accessibilityalert=""
        data-analyticsdescription="Las cookies de Analytics nos permiten ver el uso del sitio web."
        data-analyticslabel="Cookies de Analytics"
        data-marketingdescription="Empleamos cookies de marketing para mejorar la relevancia de las campañas publicitarias."
        data-marketinglabel="Cookies de marketing"
        data-changessaved="La configuración ha sido guardada"
      />
    )
  }
  let translationDiv = null
  if (translations[language]) {
    translationDiv = translations[language]
  } else {
    translationDiv = translations.en
  }
  return (
    <>
      {translationDiv}
      <script dangerouslySetInnerHTML={returnCookieScript()} />

      <style jsx global>{`
        #ccc * {
          font-family: 'Graphik LCG Web', sans-serif !important;
          -webkit-font-smoothing: antialiased;
        }

        #ccc #ccc-notify {
          min-height: 50vh;
        }

        #ccc .ccc-notify-text {
          padding-right: 1.5rem;
        }

        #ccc #ccc-notify .ccc-notify-text > h3 {
          margin-bottom: 1rem;
          font-size: 1.6rem;
        }

        #ccc #ccc-notify .ccc-notify-text > p {
          font-size: 1rem;
          line-height: 1.4;
        }

        #ccc #ccc-content p {
          font-size: 1rem;
          line-height: 1.3;
        }

        #ccc-content #ccc-info {
          display: none;
        }

        #ccc #ccc-notify .ccc-notify-buttons {
          text-align: center;
          white-space: initial;
        }

        #ccc #ccc-notify .ccc-notify-buttons > #ccc-notify-dismiss {
          display: none;
        }

        #ccc #ccc-notify .ccc-notify-buttons > #ccc-notify-accept {
          width: 100%;
          font-size: 1.1rem;
        }

        #ccc #ccc-notify .ccc-notify-buttons > [aria-controls='ccc-module'] {
          margin: 4px;
        }

        #ccc #ccc-title {
          font-weight: 400;
          font-size: 1.5rem;
        }

        #ccc h3 {
          font-weight: 400;
          font-size: 1.3rem;
        }

        #ccc button {
          border-radius: 0 !important;
        }

        #ccc button#ccc-notify-accept {
          padding: 0.5rem 1.25rem;
          font-weight: 500;
          text-transform: uppercase;
        }

        #ccc button[aria-controls='ccc-module'] {
          font-size: 0.8rem !important;
          border: none !important;
          color: white !important;
        }
      `}</style>
    </>
  )
}
